import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

const DIVISIONS_API_URL = `${$themeConfig.app.backUrlDivisions}/divisions`

export function fetchDivisions({ mod } = {}) {
    const config = mod ? { params: { mod } } : undefined
    return Vue.axios.get(DIVISIONS_API_URL, config)
}
